import React from 'react';
import { css } from 'aphrodite/no-important';

import style from './styles';

const footerStyles = css(
  style.footer,
);

export default () => (
  <footer className={footerStyles} id="footer-element" >
    <a
      className={css(style.a)}
      href="mailto:hello@underbelly.is?cc=randal.topper@underbelly.is"
    >
      <div className={css(style.content)}>
        <h1 className={css(style.header)}>
          Let&#39;s make something great together.
        </h1>
        <h4 className={css(style.h4)}>
          Contact Us
        </h4>
      </div>
    </a>
  </footer>
);


// WEBPACK FOOTER //
// ./src/components/Footer/index.js